import _, { round } from 'lodash'
import { Concept } from '../../../../../types/Survey/Analysis/Concept'
import { BueroTypeResult } from '../../../../../types/Survey/Analysis/FactorValues'
import getTotal from './getTotal'
import getVerkehrsflaechen from './getVerkehrsflaechen'
import { BueroType, Values } from '../../../../../types/Survey/Analysis/Calculation'
import getDrucker from './getDrucker'
import getMitarbeiter from './getMitarbeiter'
import { getPercentage, roundUp } from '../../../../../utility'
import getLocker from './getLocker'
import getWorkcafe from './getWorkcafe'
import getGarderobe from './getGarderobe'

const completeAnalysisCalculation = (values: Values, result: BueroTypeResult, concept: Concept, bueroType: BueroType): BueroTypeResult => {
  let resultCopy = _.cloneDeep(result)
  // resultCopy = applyMixOptimization(resultCopy, concept)
  resultCopy.drucker = getDrucker(values)
  resultCopy.locker = getLocker(values)
  resultCopy.workcafe = getWorkcafe(values)
  resultCopy.garderobe = getGarderobe(values)

  if (bueroType === BueroType.AGIL || bueroType === BueroType.FLEX) {
    // respect the WORKSTATIONS amount
    const workstations = isFinite(values?.WORKSTATIONS?.amount) ? values.WORKSTATIONS.amount : 0
    const mitarbeiterWithoutWorkstations = values.mitarbeiter - workstations > 0 ? values.mitarbeiter - workstations : 0
    const schreibtischePracticalPreRound = getPercentage(mitarbeiterWithoutWorkstations, values.desksharingPercentage.percentage)

    resultCopy.schreibtische = {
      theoreticalAmount: schreibtischePracticalPreRound + workstations,
      // check for 100 is necessary because percentage calculation can lead to a number that is not a whole number
      practicalAmount:
        workstations +
        (values.desksharingPercentage.percentage === 100 ? round(schreibtischePracticalPreRound) : roundUp(schreibtischePracticalPreRound)),
    }
  } else {
    const schreibtischePracticalPreRound = getPercentage(values.mitarbeiter, values.desksharingPercentage.percentage)
    resultCopy.schreibtische = {
      theoreticalAmount: schreibtischePracticalPreRound,
      // check for 100 is necessary because percentage calculation can lead to a number that is not a whole number
      practicalAmount:
        values.desksharingPercentage.percentage === 100 ? round(schreibtischePracticalPreRound) : roundUp(schreibtischePracticalPreRound),
    }
  }
  resultCopy.total = getTotal(resultCopy)
  resultCopy.verkehrsflaechen = getVerkehrsflaechen(resultCopy, concept, bueroType)
  resultCopy.mitarbeiter = getMitarbeiter(values)
  resultCopy.total = getTotal(resultCopy)
  return resultCopy
}

export default completeAnalysisCalculation
